/**
 * WizardLayout
 *
 * Main layout for the AEO Onboarding Wizard.
 * Provides sidebar with step navigation and main content area.
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface WizardLayoutProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
  className?: string;
}

export function WizardLayout({ children, sidebar, className }: WizardLayoutProps) {
  return (
    <div className={cn('flex min-h-[600px] rounded-lg border bg-background', className)}>
      {/* Sidebar with steps */}
      <div className="w-64 border-r bg-muted/30 p-4 flex flex-col">
        {sidebar}
      </div>

      {/* Main content area */}
      <div className="flex-1 p-6">
        {children}
      </div>
    </div>
  );
}
